<template>
  <Cockpit />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
